/**
 * Signing gate (ADR-0102 addendum 2): a beta contract cannot proceed to
 * signing while any suggestion (in any document) or field request is open.
 * Shown pre-emptively from the counts, and from a server refusal
 * (`open_review_items`).
 */

import { Link } from 'react-router-dom';
import { reviewHref, signingGateText, type OpenReviewItems } from './review-model.js';

export function SigningGateNotice({
  contractId,
  items,
  documentLabel,
}: {
  contractId: string;
  items: Pick<OpenReviewItems, 'openSuggestions' | 'openFieldRequests'> & Partial<Pick<OpenReviewItems, 'byDocument'>>;
  documentLabel?: (attachmentId: string | null) => string;
}) {
  const text = signingGateText(items);
  if (!text) return null;
  const docs = (items.byDocument ?? []).filter((d) => d.count > 0);
  const view = items.openSuggestions > 0 && items.openFieldRequests === 0 ? 'text' : 'uppgifter';
  return (
    <div role="alert" className="rounded border border-amber-300 bg-amber-50 p-3 text-xs text-amber-900">
      <p>{text}</p>
      {documentLabel && docs.length > 1 && (
        <ul className="mt-1 list-disc pl-4">
          {docs.map((d) => (
            <li key={d.attachmentId ?? 'main'}>
              {documentLabel(d.attachmentId)}: {d.count}
            </li>
          ))}
        </ul>
      )}
      <Link to={reviewHref(contractId, view)} className="mt-1.5 inline-block font-medium underline">
        Öppna granskningen
      </Link>
    </div>
  );
}
